import { useMemo } from 'react'
import { MdApps, MdPersonOutline } from 'react-icons/md'
import { Dropdown, DropdownContent, Flex, Icon, Typography, useDisclosure } from '@nilohealth/core-ui'
import { useCareProvider } from '@providers/providers.hooks'

import { NavbarIconWrapper, NavbarMenuItem, NavbarMenuTrigger } from './navbar.styles'

const NavbarMenu = () => {
  const { isOpen, setIsOpen } = useDisclosure()

  const { careProvider } = useCareProvider()

  const navbarMenuItems = useMemo(() => {
    return [
      {
        icon: MdPersonOutline,
        name: 'Care',
        description: 'Gestão de pacientes',
        link: careProvider?.domains.professional?.[0] ? `https://${careProvider?.domains.professional?.[0]}` : '',
      },
    ]
  }, [careProvider])

  const openLink = (href: string) => {
    if (href) {
      Object.assign(document.createElement('a'), {
        target: '_blank',
        rel: 'noopener noreferrer',
        href,
      }).click()
    }
  }

  return (
    <Flex>
      <Dropdown open={isOpen} onOpenChange={setIsOpen}>
        <NavbarMenuTrigger active={isOpen}>
          <Icon
            icon={MdApps}
            size={{ '@xs': 'small', '@sm': 'medium', '@md': 'medium', '@lg': 'medium', '@xl': 'medium' }}
          />
        </NavbarMenuTrigger>

        <DropdownContent align="start" sideOffset={16} loop asChild>
          <Flex direction="column" gap="nano">
            {navbarMenuItems.map(item => (
              <NavbarMenuItem key={item.name} onSelect={() => openLink(item.link)}>
                <Flex align="start" gap="nano" css={{ padding: '$nano $xxxsmall' }}>
                  <NavbarIconWrapper primary>
                    <Icon icon={item.icon} size="medium" />
                  </NavbarIconWrapper>

                  <Flex direction="column">
                    <Typography type="paragraphXSmall" weight="semibold" color="neutralLowDark">
                      {item.name}
                    </Typography>

                    <Typography type="paragraphXSmall" weight="regular" color="neutralLowLight">
                      {item.description}
                    </Typography>
                  </Flex>
                </Flex>
              </NavbarMenuItem>
            ))}
          </Flex>
        </DropdownContent>
      </Dropdown>
    </Flex>
  )
}

export default NavbarMenu
